import { render } from "./FlightMulitSkeletonItem.vue?vue&type=template&id=c197921a"
import script from "./FlightMulitSkeletonItem.vue?vue&type=script&lang=js"
export * from "./FlightMulitSkeletonItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__